module.exports = __webpack_public_path__ + "static/media/SWSCRC2-01.fb391da0.mp3";